// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ContainerOutlinedSvg from "@fishx/icons-svg/es/asn/ContainerOutlined";
import FishxIcon from '../components/FishxIcon';

var ContainerOutlined = function ContainerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ContainerOutlinedSvg
  }));
};

ContainerOutlined.displayName = 'ContainerOutlined';
export default React.forwardRef(ContainerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ContainerOutlined.js
// module id = 2311
// module chunks = 0